import { WorkspaceDescriptor } from '@synapex/shared2/entities';
import { Location as ReactRouterLocation } from 'react-router';
import {
  AdvertiserAccount,
  Workspace,
  NewAccountChannelRequest,
  ExistentAccountChannelRequest,
} from '../entity';

const finalPathnameOrPrefix = (finalPathname?: string) =>
  finalPathname ? `/${finalPathname}` : `?prefix`;

//root
export const ROOT_PATH = {
  accountNew: 'account/new',
  accountNewWorkspace: 'account/new/workspace',
  accountNewChannel: 'account/new/workspace/channel',
};

//new account channel request
export const newAccountChannelRequestPath = ({
  telegram_channel_id,
}: NewAccountChannelRequest) => {
  return `/channel-request/${telegram_channel_id}`;
};

//account

export const accountPath = (
  { advertiser_account_id }: Pick<AdvertiserAccount, 'advertiser_account_id'>,
  fp?: 'complete' | 'workspace/new',
) => {
  return `/account/${advertiser_account_id}${finalPathnameOrPrefix(fp)}`;
};

//workspace
type WorkspacePathname =
  | 'new-workspace'
  | 'referral'
  | `settings/${'marking' | 'documents' | 'site-integration' | 'permissions' | 'subscription'}`
  | `analytics/${'links' | 'retention' | 'audience'}`
  | `analytics/links/${number}`;

export const wdPath = (
  aa: Pick<AdvertiserAccount, 'advertiser_account_id'> | null,
  { workspace_type, workspace_id }: WorkspaceDescriptor,
  fp?: WorkspacePathname,
) => {
  const account = aa ? `/account/${aa.advertiser_account_id}` : '';
  return `${account}/workspace/${workspace_type}/${workspace_id}${finalPathnameOrPrefix(fp)}`;
};

export const workspacePath = (ws: Workspace, fp?: WorkspacePathname) => {
  const workspace_id =
    ws.workspace_type === 'site' ? ws.site_id : ws.channel_id;

  const { advertiser_account_id, workspace_type } = ws;
  const account = advertiser_account_id
    ? `/account/${advertiser_account_id}`
    : '';
  return `${account}/workspace/${workspace_type}/${workspace_id}${finalPathnameOrPrefix(fp)}`;
};

//channel request
export const channelRequestPath = ({
  advertiser_account_id,
  telegram_channel_id,
}: ExistentAccountChannelRequest) => {
  return (
    `/account/${advertiser_account_id}` +
    `/channel-request/${telegram_channel_id}`
  );
};

//path checkers
export const isEnteringNewAccountName = (location: ReactRouterLocation) =>
  location.pathname.endsWith('account/new');

export const isCreatingNewAccount = (location: ReactRouterLocation) =>
  location.pathname.includes('account/new');

export const isCreatingNewWorkspace = (location: ReactRouterLocation) =>
  location.pathname.includes('new-workspace') ||
  location.pathname.includes('workspace/new');

// export const isEnteringNewAccount = (location: ReactRouterLocation) =>
//     location.pathname.endsWith('account/new')
